import { stringToIntegerSchema } from './parsers';
import { App, Menu } from '../generated/graphql';

type AppId = `${number}`;
type VirtualBrandAppId = `virtual.${number}.${string}`;

/**
 * Combines app id and brand id
 */
export const toVirtualBrandId = <BrandIdArg extends string | undefined = undefined>(
  appId: number,
  brandId?: BrandIdArg
): BrandIdArg extends string ? VirtualBrandAppId : AppId =>
  (brandId ? `virtual.${appId}.${brandId}` : `${appId}`) as BrandIdArg extends string ? VirtualBrandAppId : AppId;

/**
 * Extracts app id and brand id from combined id
 * @param id
 * @return {{appId: number, brandId: string} | {appId: number}}
 */
export const fromVirtualBrandId = (id: string): { appId: number; brandId?: string } => {
  if (id.startsWith('virtual.')) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, appId, brandId] = id.split('.');
    if (!appId) {
      throw Error(`Validation error: empty app id in virtual brand id - ${id}`);
    }
    if (!brandId) {
      throw Error(`Validation error: empty brand id in virtual brand id - ${id}`);
    }
    return { appId: stringToIntegerSchema.parse(appId), brandId };
  }
  return { appId: stringToIntegerSchema.parse(id) };
};

export const appNameWithBrand = (app: App, hasBrands: boolean, venueName: string): string =>
  hasBrands ? `${app.name} (${app.brand ? app.brand.name : venueName})` : app.name;

export const venueHasBrands = (menus: Menu[]): boolean => menus.some((menu) => menu.apps.some((app) => app.brand));
